import axios from 'axios'

let apiURI = process.env.REACT_APP_SERVERAPI

export const api = axios.create({
    baseURL: apiURI,
    withCredentials: true,
})

// Attach Bearer token to internal API requests only
api.interceptors.request.use((config) => {
    if (config.url?.startsWith('https://')) return config;
    try {
        const raw = localStorage.getItem('reilm.auth');
        const token = raw ? JSON.parse(raw)?.accessToken : null;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    } catch {
        // localStorage unavailable — proceed without token
    }
    return config;
});

// On 401, clear stale session and redirect to login
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem('reilm.auth');
            window.location.hash = '#/login';
        }
        return Promise.reject(error);
    }
);
